<template>
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item"><router-link to="/"><i class="fas fa-home d-sm-none" aria-hidden="true"></i><span class="d-sm-inline d-none">Home</span></router-link></li>
			<li v-if="!menuLink" class="breadcrumb-item"><a href="javascript:void(0);" class="icon-breadcrumb" @click="moduleBreadcrumbClicked">{{ moduleName }}</a></li>
			<li class="breadcrumb-item active d-lg-inline-block d-none"><span>{{ pageName }}</span></li>
		</ol>
	</nav>
</template>

<script>
// @ is an alias to /src
import { EventBus } from '@/event-bus.js'

export default {
	name: 'Breadcrumb',
	props: {
		showNav: Boolean,
		moduleArray: Array
	},
	data() {
		return {
			currentModuleObject: [],
			menuLink: false,
			moduleName: "",
			modulePages: [],
			pageName: "",
			routerPathArray: []
		}
	},
	computed: {
		routerPathArrayLength: function() {
			return this.routerPathArray.length;
		}
	},
	mounted() {
		this.routerPathArray = this.$router.currentRoute.path.replace("/",'').split("/");
		// Route Updates
		this.$router.afterEach(() => {
			this.routerPathArray = this.$router.currentRoute.path.replace("/",'').split("/")
		});
	},
	watch: {
		routerPathArray: function() {
			// Find Object In Array Based On Object's Property
			this.currentModuleObject = this.moduleArray.find(obj => obj.moduleName == this.toTitleCase(this.routerPathArray[0]));
			// Update Properties
			this.menuLink = this.currentModuleObject.menuLink;
			this.moduleName = this.currentModuleObject.moduleName;
			this.modulePages = this.currentModuleObject.modulePages;
			this.pageName = (this.routerPathArrayLength > 1) ? this.toTitleCase(this.routerPathArray[this.routerPathArrayLength - 1].replace("-",' ')) : this.toTitleCase(this.routerPathArray[this.routerPathArrayLength - 1]);
		}
	},
	methods: {
		moduleBreadcrumbClicked: function() {
			// Show Menu Modal
			EventBus.$emit('show-menu-modal',this.moduleName,this.modulePages);
		}
	}
}
</script>
